<template>
  <div v-if="isSIT" class="pioauthback">
    <span class="grant_code" v-if="$route.query.code">
      code: {{ $route.query.code }}
    </span>
    <span v-else-if="$route.query.error_code">
      error_code: {{ error_code }}
    </span>
    <div class="grant_code" v-else-if="$route.query.piInit">
      GRANT_CODE: {{ grant_code }}
    </div>
    <span v-else>抓取 code 或 error_code 失敗</span>
    <div class="getAccessToken">
      getAccessToken結果：
      {{ getAccessTokenResult }}
    </div>
    <div class="getAccessToken">
      getPiMe
      {{ getPiMeResult }}
    </div>
    <div class="getAccessToken">
      getPiUserInfo
      {{ getPiUserInfoResult }}
    </div>
    <div class="getAccessToken">
      getPiUserPoint
      {{ getPiUserPointResult }}
    </div>
    <v-btn class="my-2 text-red justify-center" outlined @click="goHome">
      前往商城
    </v-btn>
    <v-btn
      :disabled="!redirect"
      class="my-2 text-red justify-center"
      outlined
      @click="goRedirect"
    >
      進行跳轉{{ redirect }}
    </v-btn>
  </div>
  <Spinner v-else bgc="#f6f6f6" />
</template>
<script>
import Spinner from '@/components/shared/Spinner.vue'
export default {
  name: 'pioauthback',
  components: {
    Spinner,
  },
  data: function() {
    return {
      isSIT: 1,
      grant_code: '',
      getAccessTokenResult: '',
      getPiMeResult: '',
      getPiUserPointResult: '',
      getPiUserInfoResult: '',
      errorCodeMap: {
        invalid_request: '無效的請求',
        invalid_scope: '無限的權限項目',
        invalid_client: '無效的 oAuth App',
        unauthorized_client: '無法認證的oAuth App',
        unsupported_response_type: 'response_type 參數數值錯誤',
      },
      redirect: null,
    }
  },
  methods: {
    goHome() {
      this.$router.push({
        name: 'home',
        query: { code: this.$route.query.code },
      })
    },
    goRedirect(path) {
      if (path) {
        this.$router.replace({
          path: path,
        })
      } else {
        this.$router.replace({
          name: 'home',
          query: { code: this.$route.query.code },
        })
      }
    },
    async handlePiInfo() {
      this.getAccessTokenResult = JSON.parse(
        localStorage.getItem('PI_TOKEN')
      ).access_token.slice(0, 5)
      this.getPiMeResult = localStorage.getItem('PI_UID')
      this.getPiUserPointResult = localStorage.getItem('PI_POINTS')

      const res = await api.getPiUserInfo(
        JSON.parse(localStorage.getItem('PI_TOKEN')).access_token,
        this.getPiMeResult
      )
      this.getPiUserInfoResult = res.data
    },
    async refresh_token() {
      try {
        const res = await api.getPiRefreshToken(
          JSON.parse(localStorage.getItem('PI_TOKEN')).refresh_token
        )
        res.data.active_time = Date.now() + res.data.expires_in * 1000
        localStorage.setItem('PI_TOKEN', JSON.stringify(res.data))
        this.getAccessTokenResult = JSON.parse(
          localStorage.getItem('PI_TOKEN')
        ).access_token.slice(-5)
        return true
      } catch (error) {
        this.$bus.$emit('callAllert', {
          messageContent: JSON.stringify(error),
          callback: () => {
            console.log('PRD應離開商城？DEV先不管')
          },
        })
      }
    },
  },
  computed: {
    error_code() {
      return this.$route.query.error_code
        ? this.errorCodeMap[this.$route.query.error_code]
        : ''
    },
  },
  created() {
    this.$bus.$on('piInitDone', this.handlePiInfo)
    this.isSIT = process.env.VUE_APP_USE_DEV == 'true'
    if (this.$route.query.piInit) {
      this.grant_code = localStorage.getItem('PI_GRANT_CODE')
      this.redirect = localStorage.getItem('PI_REDIRECT')
      this.goRedirect(localStorage.getItem('PI_REDIRECT'))
      this.handlePiInfo()
    }
  },
}
</script>

<style scoped>
.grant_code {
  font-size: 9px;
  width: 80%;
  overflow-x: scroll;
}
</style>
